import { Component, inject } from '@angular/core';
import { CommonModule } from "@angular/common";
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from "@ng-bootstrap/ng-bootstrap";
// import {userDropdownItems} from '@layouts/components/data';
import { Router, RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { NewPwComponent } from '@/app/pages/auth/new-pw/new-pw.component';
import { AuthService } from '@core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@core/services/language.service';

@Component({
  selector: 'app-user-profile-topbar',
  imports: [
    CommonModule,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownToggle,
    NgIcon,
    TranslateModule
  ],
  templateUrl: './user-profile.component.html'
})
export class UserProfileComponent {
  router = inject(Router);
  modalService = inject(NgbModal);
  authService = inject(AuthService);
  languageService = inject(LanguageService)

  username = localStorage.getItem("username")?.toString();

 

  openNewPassword() {
    this.modalService.open(NewPwComponent);
  }

  onLogout(): void {
    this.authService.logout().subscribe((ok) => {
      if (ok) {
        console.log('Đăng xuất thành công');
        this.router.navigate(['/auth/sign-in']);
      } else {
        console.warn('Logout thất bại');
      }
    });
  }

}
